export const getOperation = (query: string): string => {
  const matches = query.trim().match(/^(\w+)\s+(\w+)/);

  return matches !== null ? matches[2] : 'No Name Found';
};
